/// <reference path="../jquery.validate.min.js" />
/// <reference path="../jquery.validate.unobtrusive.js" />
/*
 * Script that listens for form posts that are marked to be ajax submissions
 */
(function ($) {
    //form submit override to catch forms that should try to submit using ajax instead
    $(document.body).on('submit', 'form.form-ajax', function (e) {
        e.preventDefault();
        var $form = $(this);

        //make sure that the form is valid before submitting it
        if (typeof $.fn.valid === 'function' && !$form.valid()) {
            return;
        }

        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serialize()
        }).done(function (response) {
            var responseElement = $(response);

            //if the response is the original posted form, the response is a partial response
            //and we should only update the form content
            if (responseElement.is('form')) {
                $form.html(responseElement.html());
                if ($.validator && $.validator.unobtrusive) {
                    $.validator.unobtrusive.parse($form);
                }
            }
        });
    });
})(jQuery);